import { Observable } from 'rxjs';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';
import {
  INotification,
  INotificationStage,
  INotificationType,
  NotificationType,
  StageNotification
} from 'src/app/models/notification';
import { SHOW_LOADER } from '../loader-interceptor.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  baseUrls: { [key: string]: string } = {
    baseUrlContracts: `${environment.apis.unified.baseUrl}/${environment.apis.unified.microservices.contract}`
  };

  context = new HttpContext().set(SHOW_LOADER, false);

  constructor(private _http: HttpClient) {}

  getStorageStatus(statusName: NotificationType): INotificationStage | null {
    let storage = sessionStorage.getItem(
      `${environment.storagePrefix}_${statusName}`
    ) as string;

    if (storage) return JSON.parse(storage) as INotificationStage;

    return null;
  }

  setStorageStatus(
    statusName: NotificationType,
    stage: StageNotification = 'open',
    badgeNumber: number = 0
  ): void {
    const status: INotificationStage = {
      stage,
      badgeNumber
    };
    sessionStorage.setItem(
      `${environment.storagePrefix}_${statusName}`,
      JSON.stringify(status)
    );
  }

  removeStorageStatus(statusName: NotificationType): void {
    sessionStorage.removeItem(`${environment.storagePrefix}_${statusName}`);
  }

  removeAllStorageStatus(): void {
    sessionStorage.clear();
  }

  getStorageContracts(statusName: NotificationType): INotification[] | null {
    let sessionValue = sessionStorage.getItem(
      `${environment.storagePrefix}_${statusName}`
    );

    if (sessionValue) return JSON.parse(sessionValue);
    else return null;
  }

  setStorageContracts(
    statusName: NotificationType,
    contracts: INotification[]
  ): void {
    sessionStorage.setItem(
      `${environment.storagePrefix}_${statusName}`,
      JSON.stringify(contracts)
    );
  }

  removeStorageContracts(statusName: NotificationType): void {
    sessionStorage.removeItem(`${environment.storagePrefix}_${statusName}`);
  }

  getCountNotification(): Observable<INotificationType[]> {
    return this._http.get<INotificationType[]>(
      `${this.baseUrls['baseUrlContracts']}/notification?userId=Unknown`,
      { context: this.context }
    );
  }

  getNotificationsByType(type: NotificationType): Observable<INotification[]> {
    return this._http.get<INotification[]>(
      `${this.baseUrls['baseUrlContracts']}/notification/${type}?userId=Unknown`,
      { context: this.context }
    );
  }
}
